import { useQuery } from "@tanstack/react-query";
import { getRouteApi, Link, useNavigate } from "@tanstack/react-router";
import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { Empty, ErrorBox, PageHeader, Spinner } from "../components/ui";
import { api } from "../lib/api";

const route = getRouteApi("/_app/busca");

export function SearchPage() {
  const { q = "" } = route.useSearch();
  const navigate = useNavigate();
  const [text, setText] = useState(q);

  useEffect(() => setText(q), [q]);

  // Atualiza a URL 300 ms depois que a pessoa para de digitar.
  useEffect(() => {
    const t = setTimeout(() => {
      const v = text.trim();
      if (v !== q) void navigate({ to: "/busca", search: { q: v || undefined }, replace: true });
    }, 300);
    return () => clearTimeout(t);
  }, [text, q, navigate]);

  const enabled = q.trim().length >= 2;
  const r = useQuery({
    queryKey: ["search", q],
    queryFn: () => api.unwrap(api.client.GET("/v1/search", { params: { query: { q } } })),
    enabled,
  });

  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader title="Buscar" />
      <div className="relative mb-6">
        <Search className="pointer-events-none absolute top-3 left-3 h-5 w-5 text-muted" aria-hidden />
        <input
          type="search"
          autoFocus
          className="field py-3 pl-11 text-base"
          placeholder="Título da aula ou do curso"
          aria-label="Buscar"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>
      {!enabled ? (
        <p className="text-sm text-muted">Digite ao menos 2 letras.</p>
      ) : r.isPending ? (
        <Spinner />
      ) : r.isError ? (
        <ErrorBox error={r.error} />
      ) : r.data.items.length === 0 ? (
        <Empty title="Nada encontrado">Tente outra palavra.</Empty>
      ) : (
        <ul className="card divide-y divide-line overflow-hidden">
          {r.data.items.map((i) => (
            <li key={i.lesson_id}>
              <Link
                to="/aula/$lessonId"
                params={{ lessonId: i.lesson_id }}
                className="block px-4 py-3 hover:bg-raised"
              >
                <p className="text-sm font-semibold">{i.lesson_title}</p>
                <p className="text-xs text-muted">
                  {i.course_title} · {i.module_title}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
